import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ThemeService } from '@services/theme.service';
import { IAuthConfig } from '@shared/system-config/system-config.interface';

export const clientPanelGuard: CanActivateFn = (route, state) => {
  const router = new Router;
  const userItem = sessionStorage.getItem('user');
  const user = userItem ? JSON.parse(userItem) : null;
  const themeService = inject(ThemeService);
  const permissions = themeService.getPermissions();

  const themeClientRoles = permissions().filter((item: IAuthConfig) => item.type === 'CLIENT').map((item: IAuthConfig) => item.role);

  if (permissions().length) {
    if (themeClientRoles.some((item: string) => user?.authorities?.includes(item)) && !user.confirmPersonalData) {
      return true;
    }
  } else {
    if (user?.authorities.some((item: string) =>
      item === 'ROLE_QIMA_REQUESTER' ||
      item === 'ROLE_MINERVA_REQUESTER' ||
      item === 'ROLE_ACELEN_REQUESTER' ||
      item === 'ROLE_IRANCHO_REQUESTER' ||
      item === 'ROLE_WALMART_REQUESTER' ||
      item === 'ROLE_SAFETRACE_REQUESTER' ||
      item === 'ROLE_INTERSTATE_MEAT_DISTRIBUTORS_REQUESTER' ||
      item === 'ROLE_ASSAI_REQUESTER' ||
      item === 'ROLE_THOMAS_FOODS_REQUESTER' ||
      item === 'ROLE_SAFE_SUPORTE' ||
      item === 'ROLE_GRAOSDOPARA_REQUESTER'
    ) && !user.confirmPersonalData) {
      return true;
    }
  }
  router.navigate(['/']);
  return false;
};
